import { render, staticRenderFns } from "./SurfacePostAttachmentEmbedControl.vue?vue&type=template&id=980fc396&"
import script from "./SurfacePostAttachmentEmbedControl.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostAttachmentEmbedControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports